import React from 'react';
import LandingPage from '../components/LandingPage';

export default function EdmontonHiddenGems() {
  return (
    <LandingPage
      testid="edmonton-hidden-gems-page"
      slug="edmonton-hidden-gems"
      title="Edmonton Hidden Gems: The Restaurants Locals Keep Quiet"
      metaTitle="Edmonton Hidden Gem Restaurants — Where Locals Actually Eat | Culinera"
      metaDescription="Skip the chains. A local's guide to Edmonton hidden gems: Old Strathcona and 124 Street favourites, Filipino and Korean home cooking, farm-to-table rooms, and cult bakeries. Plan a free Edmonton food trip with Culinera."
      heroImage="edmonton-hidden-gems.jpg"
      heroAlt="Cozy intimate Edmonton neighbourhood eatery in Old Strathcona at dusk with warm string lights, shared plates, and a food truck visible outside"
      kicker="Edmonton Food Guide"
      wizardCity="Edmonton"
      wizardCuisines={['Farm-to-Table', 'International']}
      picksHeading="Edmonton hidden gems worth the detour"
      restaurantIds={[
        'pip', 'three-boars', 'tres-carnales', 'dadeos', 'yelo',
        'padmanadi', 'koto', 'little-brick', 'meuwlys', 'partake',
        'nongbu', 'rge-rd',
      ]}
      ctaHeading="Plan your Edmonton food trip"
      ctaText="Turn these Edmonton hidden gems into a day-by-day food itinerary across Old Strathcona, 124 Street and the river valley."
      intro={[
        "Edmonton has always been a great eating city that refuses to market itself — which is exactly why its best tables stay off the tourist radar. If you're hunting for **Edmonton hidden gems**, the trick is knowing that the city's food culture lives in two neighbourhoods on opposite sides of the river, each with its own personality.",
        "South of the North Saskatchewan, **Old Strathcona** and Whyte Avenue are the artsy, late-night, second-generation-immigrant quarter: Three Boars for small plates, Dadeo's for Cajun po' boys, Tres Carnales for the city's best al pastor tacos, and Pip's ever-changing blackboard menu. The Saturday Old Strathcona Farmers' Market is the spine of the whole local food scene.",
        "Across the river, **124 Street** is the chef-driven, design-conscious side of town — RGE RD's whole-animal Alberta cooking, Café Linnea's French-Nordic brunch, Duchess Bake Shop's cult macarons. Tucked between them are the genuine sleepers: Yelo'd in Little Manila, Padmanadi's beloved vegan Indonesian, Koto's 30-year-old sushi counter, and Little Brick's river-valley café.",
        "These are the **best hidden restaurants in Edmonton** — real, operating rooms locals would rather you didn't crowd. Tap any of them for details, then build the whole thing into a personalized food itinerary.",
      ]}
      faqs={[
        {
          q: 'What are the best hidden gem restaurants in Edmonton?',
          a: 'Local favourites that fly under the tourist radar include Pip and Three Boars in Old Strathcona, Tres Carnales for tacos, Padmanadi for vegan Indonesian, Koto for old-school sushi, and Little Brick Café in the river valley.',
        },
        {
          q: 'Where do locals eat in Edmonton?',
          a: 'Edmonton\'s food culture splits across Old Strathcona / Whyte Avenue (casual, late-night) and 124 Street (chef-driven, fine dining). Most locals work both sides of the river depending on the occasion.',
        },
        {
          q: 'Is Edmonton good for food?',
          a: 'Yes — Edmonton runs one of the most underrated food scenes in Canada, especially for farm-to-table, Filipino and Korean home cooking, craft breweries, and pastry. It just doesn\'t advertise itself.',
        },
      ]}
    />
  );
}
